import { type BadgeVariant, DotBadge } from '@tempo-io/sui-badge';

export const AlertDot = ({
  variant = 'warning',
  'data-testid': testId = 'alert-dot',
}: {
  variant?: BadgeVariant;
  'data-testid'?: string;
}) => <DotBadge data-testid={testId} variant={variant} className="absolute -top-1 -right-1" />;
